import axios from 'axios';
import { BaseUrl } from '../../server';


export const getFilltercases = (page ,limit, caseNumber,clientName,opponentName,caseType,courtType,courtName,nextSessionDate) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_cases_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/case/filter`,{
            params: {
                page,
                limit,
                caseNumber,
                clientName,
                opponentName,
                caseType,
                courtType,
                courtName,
                nextSessionDate
            },
            withCredentials: true,
        });

   
        dispatch({
            type: 'get_Fillter_cases_success',
            payload: {
                cases: data.cases,
                pagination: data.pagination,
            },
        });

    } catch (error) {
      
        dispatch({
            type: "get_Fillter_cases_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};

export const getUserCases = (page , limit) => async (dispatch) => {
    try {
      
        dispatch({ type: 'get_User_cases_request' });


        const { data } = await axios.get(`${BaseUrl}/case/user`,{
            params: {
                page,
                limit,
             
            },
            withCredentials: true,
        });
        dispatch({
            type: 'get_User_cases_success',
            payload: {
                cases: data.cases,
                pagination: data.pagination,
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_User_cases_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};


export const getcase = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_case_request' });

        const { data } = await axios.get(`${BaseUrl}/case/${id}`);
        console.log("data",data);
        dispatch({ type: 'get_case_success' ,payload:data.casee});

    } catch (error) {
        dispatch({
            type: "get_case_error",
            payload: error.response.data.message,
          });
    }
}